<div class="loading-background">
  <img [src]="baseHref + 'assets/images/new_loading.gif' " alt="Loading...">
</div>
